import Type from "@/model/types/Type";

const type = {
    PENDING : 1,
    FINISHED : 2,
}

const list = [
    {
        value: type.PENDING,
        text: "Pendente",
    },
    {
        value: type.FINISHED,
        text: "Finalizada",
    },
]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}


